import { useEffect } from "react";
import { useU2000DefaultRouting } from "../../hooks/useU2000DefaultRouting";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";

/**
 * Composant qui gère la redirection automatique vers l'écran par défaut
 * Remplace le <Navigate to="/U3400" replace /> dans les routes
 * Ne redirige que lors d'un nouveau login, pas lors d'un F5/refresh
 */
const U2000DefaultRedirect: React.FC = () => {
  const { auth, clearNewLoginFlag } = useU2000AuthContext();
  const defaultRouting = useU2000DefaultRouting({
    luName: "mainMenu",
    fallbackPath: "/U3400",
  });

  useEffect(() => {
    // Rediriger uniquement si c'est un nouveau login
    // Si isNewLogin est false, c'est un refresh (F5) - ne pas rediriger
    if (auth.isNewLogin === true) {
      // Valider et nettoyer l'écran par défaut si nécessaire
      defaultRouting.validateDefaultScreen();

      // Naviguer vers l'écran par défaut ou fallback
      defaultRouting.navigateToDefault();

      // Nettoyer le flag pour éviter des redirections futures non désirées
      clearNewLoginFlag();
    }
    // Si isNewLogin est false ou undefined, ne rien faire - laisser React Router gérer la route actuelle
  }, [auth.isNewLogin, defaultRouting.validateDefaultScreen, defaultRouting.navigateToDefault, clearNewLoginFlag]);

  // Effet séparé pour gérer les changements d'organisation
  useEffect(() => {
    if (auth.isAuthenticated && auth.user.organizationId) {
      // Vérifier s'il y a un écran par défaut pour cette organisation
      const defaultRoute = defaultRouting.getDefaultRoute();

      // Si il y a un écran par défaut différent de la page actuelle, naviguer
      if (defaultRoute && window.location.pathname !== defaultRoute) {
        defaultRouting.navigateToDefault();
      }
    }
  }, [auth.user.organizationId, defaultRouting.getDefaultRoute, defaultRouting.navigateToDefault]);

  // Ce composant ne rend rien, il gère seulement la navigation
  return null;
};

export default U2000DefaultRedirect;
